import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const DRAG_HANDLE_CELL_CLASS_NAME = 'DragHandleCell';

export const DRAG_HANDLE_CELL_CLASS_SLOTS = ['root'] as const;

export type DragHandleCellClassSlot =
	(typeof DRAG_HANDLE_CELL_CLASS_SLOTS)[number];

export interface DragHandleCellClasses {
	root: string;
	isDragging: string;
}

export type DragHandleCellClassKey = keyof DragHandleCellClasses;

export const getDragHandleCellUtilityClass = (slot: string) =>
	generateUtilityClass(DRAG_HANDLE_CELL_CLASS_NAME, slot);

export const dragHandleCellClasses = generateUtilityClasses<
	keyof DragHandleCellClasses
>(DRAG_HANDLE_CELL_CLASS_NAME, ['root', 'isDragging']);
export default dragHandleCellClasses;
